import { combineReducers } from 'redux'
import { Reducer } from 'interfaces'
import { LocationAppState, LocationsAutosuggestState } from 'interfaces/locations'
import {
  REGISTER_LOCATIONS_AUTOSUGGEST,
  DESTROY_LOCATIONS_AUTOSUGGEST,
  SEARCH_LOCATIONS,
  SET_LOCATIONS,
  REGISTER_CITIES_AUTOSUGGEST,
  DESTROY_CITIES_AUTOSUGGEST,
  SEARCH_CITIES,
  SET_CITIES,
} from 'actions/locationsActions'
import { DEFAULT_LOCATIONS_LOADING_STATE, locationToOption, cityToOption } from 'helpers/cityHelpers'
import * as omit from 'lodash/omit'

const locations: Reducer<LocationsAutosuggestState> = (state = {}, action) => {
  switch (action.type) {
    case REGISTER_LOCATIONS_AUTOSUGGEST: {
      return {
        ...state,
        [action.payload]: DEFAULT_LOCATIONS_LOADING_STATE,
      }
    }

    case DESTROY_LOCATIONS_AUTOSUGGEST: {
      return omit(state, action.payload)
    }

    case SEARCH_LOCATIONS: {
      const autosuggestState = state[action.payload.id]
      if (!autosuggestState) {
        return state
      }

      return {
        ...state,
        [action.payload.id]: {
          ...autosuggestState,
          loading: true,
          lastSentQuery: action.payload.query,
        },
      }
    }

    case SET_LOCATIONS: {
      const autosuggestState = state[action.payload.id]
      if (!autosuggestState) {
        return state
      }

      return {
        ...state,
        [action.payload.id]: {
          ...autosuggestState,
          loading: false,
          options: action.payload.locations.map(locationToOption),
        },
      }
    }

    default:
      return state
  }
}

const cities: Reducer<LocationsAutosuggestState> = (state = {}, action) => {
  switch (action.type) {
    case REGISTER_CITIES_AUTOSUGGEST: {
      return {
        ...state,
        [action.payload]: DEFAULT_LOCATIONS_LOADING_STATE,
      }
    }

    case DESTROY_CITIES_AUTOSUGGEST: {
      return omit(state, action.payload)
    }

    case SEARCH_CITIES: {
      const autosuggestState = state[action.payload.id]
      if (!autosuggestState) {
        return state
      }

      return {
        ...state,
        [action.payload.id]: {
          ...autosuggestState,
          loading: true,
          lastSentQuery: action.payload.query,
        },
      }
    }

    case SET_CITIES: {
      const autosuggestState = state[action.payload.id]
      if (!autosuggestState) {
        return state
      }

      return {
        ...state,
        [action.payload.id]: {
          ...autosuggestState,
          loading: false,
          options: action.payload.cities.map(cityToOption),
        },
      }
    }

    default:
      return state
  }
}

export default combineReducers<LocationAppState>({
  locations,
  cities,
})
